<template>
  <el-container style="width: 100%;height: 100%;display: flex;flex-direction: column;">
    <el-row style="width: 100%; height: 48px;margin-bottom: 1px;background-color: #ffffff;">
      <el-menu default-active="1" class="horizontal-menu" @select="menuSelect"
               mode="horizontal" unique-opened background-color="rgba(0, 0, 0, 0)" text-color="rgba(0, 0, 0, 1)">
        <template v-for="sub in energyItem">
          <el-menu-item class="horizontal-menu-item" :key="sub.id" :index="sub.id">
            <span style="font-size: 14px;">{{sub.name}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-row>
    <el-row style="width: 100%;height: calc(100% - 49px);display: flex;flex-direction: row;">
      <el-aside style="height: 100%;width: 250px;margin-right: 1px;overflow: hidden;background-color: #ffffff;">
        <el-row class="doc-tree-top">
          <el-input style='width: 100%; border: none; outline: none' class="filter-search" placeholder="输入关键字搜索" prefix-icon="zy-icon-search" v-model="filterName"/>
        </el-row>
        <el-tree :data="treeData" :props="defaultProps" :filter-node-method="filterNode" node-key='id'
                 :default-expanded-keys="expandKeys" ref="tree" class="aside-tree" show-checkbox :default-checked-keys="checkedKey">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <i v-if="node.data.type === '1'" class="zy-icon-building"></i>
            <i v-if="node.data.type === '2'" class="zy-icon-commit"></i>
            <i v-if="node.data.type === '3'" class="zy-icon-sensor"></i>
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </el-aside>
      <el-main style="overflow-y: hidden;font-size: 14px;width: calc(100% - 251px);height: 100%;background-color: #ffffff;">
        <el-row class="tt-input" style="width: 100%;height: 48px;line-height: 48px;color: rgb(127, 127, 127);text-align: left;">
          <span style="margin-left: 24px;">时间：</span>
          <el-radio-group v-model="radio" @change="selBack" style="margin-left: 8px;" size="small">
            <el-radio-button label="年"></el-radio-button>
            <el-radio-button label="月"></el-radio-button>
            <el-radio-button label="日"></el-radio-button>
          </el-radio-group>
          <el-date-picker v-model="startDate" style="width: 140px;margin-left: 16px" :type="type"
                          placeholder="选择日期" :value-format="format" :clearable="false"/>
          <el-button class="search-btn-blue" style="margin-left: 16px;" @click="getChartData" type="primary" size="mini">查询</el-button>
          <el-button class="search-btn-blue" style="margin-left: 20px;" @click="toExcel" type="primary" size="mini">导出</el-button>
        </el-row>
        <el-row style="background-color: #fff;width: 100%; height: 1px;"></el-row>
        <el-row style="overflow: hidden;height: calc(100% - 49px);width: 100%;" class="table">
          <el-table border fit height="calc(100% - 32px)" width='100%' :data="tableData" ref="tableData">
            <el-table-column v-for="(item,i) in tableProps" :key="i"
                           :prop="item.prop" :label="item.label" :width="(i===0)?'166px':'110px'">
            </el-table-column>
          </el-table>
          <el-pagination style='height:32px;background-color: #FFFFFF;text-align: left;width: 100%;' @current-change="handlePageChange" @size-change="handleSizeChange"
                         :current-page='currPageNo' :page-size="pageSize" :total="total"
                         layout="total, sizes, prev, pager, next, jumper" :page-sizes="[18,36,54,72,90]"
                         background/>
        </el-row>
      </el-main>
    </el-row>
  </el-container>
</template>

<script>
import * as axios from "axios";
export default {
  name: "EnergyReport",
  data() {
    return {
      radio: '日',
      selNode: '',
      checkedKey: '',
      treeData: [],
      expandKeys: [],
      defaultProps: {
        children: 'childNode',
        label: 'name'
      },
      type: 'date',
      dateType: 1,
      startDate: new Date().Format('yyyy-MM-dd'),
      props: [],
      tableProps: [],
      nameList: [],
      idList: [],
      tableData: [],
      currPageNo: 1,
      pageSize: this.GlobalConfig.PAGE_SIZE_18,
      total: 0,
      format: 'yyyy-MM-dd',
      nodeType: '3',
      nodeId: '',
      energyItem: [{'id': '1', 'name': '电'}, {'id': '2', 'name': '水'}, {'id': '11', 'name': '气'}, {'id': '12', 'name': '汽'}],
      unit: 'kWh',
      media: '1'
    }
  },
  created() {
    this.getTree('1')
  },
  watch: {
    filterName(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    menuSelect(val) {
      this.tableData = []
      this.chartData = []
      this.media = val
      this.getTree(val)
      if (val === '1') {
        this.unit = 'kWh'
      } else {
        this.unit = 'm³'
      }
    },
    getTree(val) {
      this.$api.systemManage.getSensorTree(val).then(res => {
        this.treeData = res.data
        if (this.treeData && this.treeData.length > 0) {
          this.selNode = this.getLeafNode(this.treeData[0]);
          this.checkedKey = this.selNode.id.split(',')
          this.$refs.tree.setCheckedKeys([this.selNode['id']], true)
          let nodeIdName = 'id';
          this.$nextTick(function () {
            this.setTreeCurrent(this.selNode[nodeIdName], 1);
            this.getChartData()
          })
        }
      })
    },
    getLeafNode(pNode) {
      let leafNode = pNode;
      if (pNode.childNode && pNode.childNode.length > 0) {
        leafNode = this.getLeafNode(pNode.childNode[0]);
      }
      return leafNode;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data['name'].indexOf(value) !== -1;
    },
    handlePageChange(pageNo) {
      this.currPageNo = pageNo;
      this.getChartData();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.getChartData();
    },
    setTreeCurrent(key, time) {
      if (time > 10) throw new Error('没有找到 树组件');
      let tree = this.$refs.tree;
      if (tree) {
        tree.setCurrentKey(key);
        this.expandKeys.push(key);
        let node = tree.getNode(key);
        if (key !== -1) tree.$emit("node-click", node.data, node, tree);
      } else {
        this.setTreeCurrent(key, time + 1)
      }
    },
    selBack(val) {
      if(val === '年') {
        this.dateType = 3
        this.type = 'year'
        this.startDate = new Date().Format('yyyy')
        this.format = 'yyyy'
      }
      if(val === '月') {
        this.dateType = 2
        this.type = 'month'
        this.startDate = new Date().Format('yyyy-MM')
        this.format = 'yyyy-MM'
      }
      if(val === '日') {
        this.dateType = 1
        this.type = 'date'
        this.startDate = new Date().Format('yyyy-MM-dd')
        this.format = 'yyyy-MM-dd'
      }
      this.getChartData()
    },
    handleCheckChange(checked, val) {
      if (val || this.nodeType === '3') {
        if(checked.type === '3') {
          if (this.nodeType !== '3') {
            this.$nextTick(function () {
              this.$refs.tree.setCheckedKeys(this.idList, false);
            })
            this.idList = [];
          }
          this.nodeType = checked.type;
          if(this.idList.indexOf(checked.id) <= -1) {
            if(this.nameList.length < 9) { // 限制最多只能选4块表
              this.idList.push(checked.id)
              this.nameList.push(checked.name)
              this.getChartData()
            } else {
              this.$nextTick(function () {
                this.$refs.tree.setCheckedKeys(this.idList, true)
              })
            }
          }else {
            this.nodeType = checked.type;
            this.idList.splice(this.idList.indexOf(checked.id), 1)
            this.nameList.splice(this.nameList.indexOf(checked.name), 1)
            this.getChartData()
          }
        } else if (val) {
          this.nodeId = checked.id;
          this.nodeType = checked.type;
          this.$nextTick(function () {
            this.$refs.tree.setCheckedKeys(this.idList, false);
          })
          this.idList = [];
          this.idList.push(checked.id);
          this.nameList = [checked.name];
          this.getChartData()
        }
      }
    },
    getChartData() {
      let params = {'id': this.$refs.tree.getCheckedKeys().join(","), 'dataDate': this.startDate, 'dateType': this.dateType, page: this.currPageNo,
        rows: this.pageSize, type: '3', mediaId: this.media};
      this.$api.energyReport.getEnergyForm(params).then(res => {
        this.total = res.data.total;
        this.tableProps = res.data.rows.itemList;
        this.$nextTick(() => {
          this.$refs.tableData.doLayout();
          this.tableData = res.data.rows.tableList
        });
      })
    },
    toExcel() {
      let param = []
      param.push(this.dateType)
      param.push(this.startDate)
      param.push(this.$refs.tree.getCheckedKeys().join(","));
      param.push(this.nodeType);
      param.push('1');
      let paramStr;
      paramStr = '/energyReport/energyForm' + '/exportExcel?searchData=' + param.join('_');
      paramStr += '_' + sessionStorage.getItem('token');
      window.open(axios.defaults.baseURL + paramStr);
    }
  }
}
</script>
<style scoped>
  .doc-tree-top{
    display: inline-flex;
    align-items: center;
    height: 49px;
    width: 250px;
    border-bottom: 1px solid #fff;
  }
  /*.table /deep/ .el-table tr {*/
  /*  background-color: transparent!important;*/
  /*}*/
  .table /deep/ .el-table th {
    background-color: rgba(2, 124, 247, 0.2);
    border-top: 0;
  }
  /*.table /deep/ .el-table--enable-row-transition .el-table__body td, .el-table .cell{*/
  /*  background-color: transparent;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/FormManage/EnergyReport.vue